
import { isFunction } from './typeof'
class OnPageShowListener {

    is_listening = false;
    callbacks = {};

    __visibilityChangeCallBack() {
        if (!document.hidden) {
            console.log('on page show')
            Object.keys(this.callbacks).forEach(name => {
                console.log(name)
                const func = this.callbacks[name];
                if (isFunction(func) && this.is_listening) {
                    func();
                }
            });
        } else {
            console.log('on page hide')
        }
    }

    visibilityChangeCallBack = this.__visibilityChangeCallBack.bind(this)

    //开始监听
    start() {
        if (!document) {
            throw new Error('document is not exist');
        }
        this.is_listening = true;
        document.addEventListener("visibilitychange", this.visibilityChangeCallBack);
    }

    //停止监听
    stop() {
        if (!document) {
            throw new Error('document is not exist');
        }
        this.is_listening = false;
        document.removeEventListener("visibilitychange", this.visibilityChangeCallBack)
    }


    //注册监听函数
    register(name, func) {
        if (isFunction(func) && !this.callbacks[name]) {
            this.callbacks[name] = func;
        }
    }

    //移除某个监听函数
    remove(name) {
        delete this.callbacks[name];
    }

    //清空监听函数
    clear() {
        this.callbacks = {};
    }


}

export default new OnPageShowListener();